import { render, staticRenderFns } from "./login-signup.vue?vue&type=template&id=4f44ceae&scoped=true&"
import script from "./login-signup.vue?vue&type=script&lang=js&"
export * from "./login-signup.vue?vue&type=script&lang=js&"
import style0 from "./login-signup.vue?vue&type=style&index=0&id=4f44ceae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f44ceae",
  null
  
)

/* custom blocks */
import block0 from "./login-signup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports